import Rebase from "re-base";
import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyCZ-I-oLSr6Gtic5rEJCJJ4GFNmLt6UVww",
  authDomain: "catch-of-the-day-ben-yee.firebaseapp.com",
  databaseURL: "https://catch-of-the-day-ben-yee-default-rtdb.firebaseio.com"
})

const base = Rebase.createClass(firebaseApp.database());

// This is a named export
export { firebaseApp };

// This is a default export
export default base;
